/**
 * Created by mestrad on 2018. 09. 21..
 */

export default AutoComplete;

const $ = jQuery;
const categoryTypes = [
    'location_details',
    'related_person',
    'related_person_profession',
    'related_corporate',
    'birth_place',
    'death_place'
];

function AutoComplete(config) {
    let extraFilter, extraKeyword, keyword = '';
    $(config.holderItem).select2({
        minimumInputLength: 0,
        theme: "classic",
        language: translation(config.locale),
        multiple: true,
        tokenSeparators: [','],
        width: 'resolve',
        ajax: {
            url: config.ajaxUrl + "/" + config.type,
            type: "POST",
            cache: true,
            dataType: 'json',
            quietMillis: 100,
            delay: 1000,
            data: (params) => {
                if (categoryTypes.includes(config.categoryType)) {
                    JSON.stringify(extraFilter = {
                        nnp_search_connections: [
                            {
                                type: config.categoryType,
                                search_value: params.term || ''
                            }
                        ]
                    });
                    extraKeyword = params.term;
                } else {
                    keyword = params.term;
                }

                return {
                    action: config.type,
                    object_type: config.objectType,
                    search: keyword,
                    locale: config.locale,
                    page: 1,
                    limit: 100,
                    type: config.categoryType,
                    extra_filter: extraFilter
                };
            },
            processResults: function (result) {
                if (result.data !== null) {
                    if (config.categoryType === 'related_person_profession') {
                        return formatRelatedPersonProfession(result.data.items, extraKeyword);
                    }

                    if (config.categoryType === 'location_details') {
                        return formatLocationData(result.data.items, extraKeyword);
                    }

                    if (config.categoryType === 'related_person' ||
                        config.categoryType === 'related_corporate') {
                        return formatRelatedPersonData(result.data.items, extraKeyword);
                    }

                    return config.type === 'search' ||
                           [ 'birth_place', 'death_place' ].includes(
                               config.categoryType ) ?
                           formatResponseData(result.data.items ) : {
                            results: $.map(result.data[0].items, function (item) {
                                return {
                                    text: item.value,
                                    id: item.id
                                };
                            })
                        };
                } else {
                    return {
                        results: null
                    };
                }
            }
        }
    });

    function translation(locale) {
        if(locale === "hu") {
            return {
                inputTooShort: function (args) {
                    var remainingChars = args.minimum - args.input.length;
                    var message = 'Írjon be ' + remainingChars + ' vagy több karaktert';
                    return message;
                },
                noResults: function () {
                    return 'Nincs találat';
                },
                searching: function () {
                    return 'Keresés…';
                }
            };
        } else {
            return "en";
        }
    }

    function formatLocationData( feed, extraKeyword ) {
        var data = [];
        feed.forEach( function ( item ) {
            if ( ! item.locationDetails || item.locationDetails.length === 0 ) {
                return;
            }
            item.locationDetails.forEach( function ( location ) {
                Object.entries( location ).forEach( function ( details ) {
                    if ( details[ 0 ] !==
                        'settlement' &&
                        details[ 0 ] !==
                        'county' ) {
                        return false;
                    }
                    var values = details[ 1 ][ 0 ];
                    if ( ! values.value.toLowerCase()
                            .startsWith( extraKeyword.toLowerCase() ) ||
                        data.find( function ( e ) {
                            return e.id === values.geo_id;
                        } ) ) {
                        return false;
                    }
                    data.push( {
                        id: values.geo_id,
                        text: capitalizeFirstLetter( values.value )
                    } );
                } );
            } );
        } );
        return { results: data };
    }

    function formatRelatedPersonData(feed, extraKeyword) {
        var data = [];
        feed.forEach(function (item) {
            if (!item.relatedPerson || item.relatedPerson.length === 0 ) {
                return;
            }
            item.relatedPerson.forEach(function (l) {
                if (l.value.toLowerCase().startsWith(extraKeyword.toLowerCase()) &&
                    !data.find(e => e.id === l.person_id) &&
                    l.title === 'kapcsolódó személy') {
                    data.push({
                        id: l.person_id,
                        text: capitalizeFirstLetter(l.value)
                    });
                }
            });
        });
        return {results: data};
    }

    function formatRelatedPersonProfession(feed, extraKeyword) {
        var data = [];
        feed.forEach(function (item) {
            if (!item.relatedPerson || item.relatedPerson.length === 0 ) {
                return;
            }
            item.relatedPerson.forEach(function (l) {
                if (!l.profession || l.profession.length === 0) {
                    return;
                }
                l.profession.forEach(function (p) {
                    if (!data.find(e => e.id === p.id) &&
                        p.name.toLowerCase().startsWith(extraKeyword.toLowerCase())) {
                        data.push({
                            id: p.id, text: p.name.toLowerCase()
                        });
                    }
                });
            });
        });
        return {results: data};
    }

    function formatResponseData(feed) {
        var data = [];
        feed.forEach(function (item) {
            getActiveName(item.nameList, function (name) {
                data.push({
                    id: item.id,
                    text: name
                });
            });
        });
        return {results: data};
    }

    function getActiveName( feed, callback ) {
        feed.forEach( function ( item ) {
            if ( item.active === 1 &&
                item.language === ( config.locale + 'n' ).toUpperCase() ) {
                callback( item.title );
            }
        } );
    }

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}
